export const HEADER_BLOCK_S30 = {
  "temp":{
    "templateId":30
  },
  "blockType": "HEADER",
  "blockDesign": "header_01",
  "styleProps": {
    "background-image": "url('')",
    "background-color": "#0F0F0F",
    "padding": "120px 20px 120px 20px"
  },
  "position": "center",
  "headingsStyleProps": {
    "padding": "10px 0px 10px 0px",
    "text-align": "center",
    "max-width": "896px",
    "margin": "0px auto 0px 0px"
  },
  "headingsStylePropsTab": {
    "padding": "10px 0px 10px 0px"
  },
  "headingsStylePropsMob": {
    "padding": "10px 0px 10px 0px"
  },
  "headings": [
    {
      "text": "🟢 Our work",
      "styleProps": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "padding": "14px 20px 14px 20px",
        "font-weight": "100",
        "color": "#ffffff",
        "font-family-cust": "",
        "font-family": "'Nunito', sans-serif",
        "margin": "0px 0px 20px 0px",
        "font-family-bk": "'Nunito', sans-serif",
        "text-align": "left",
        "background-color": "#1e1e1e",
        "border-radius": "9999px"
      },
      "stylePropsTab": {
        "font-size": "1.25rem",
        "line-height": "1.75rem"
      },
      "stylePropsMob": {
        "font-size": "1.125rem",
        "line-height": "1.75rem"
      },
      "alignStyleProps": {
        "text-align": "left",
        "background-color": ""
      }
    },
    {
      "text": " <span style=\"color:#ffffff\">At our place —  Transforming Businesses</span> with Innovative Software Solutions",
      "styleProps": {
        "font-size": "3.75rem",
        "line-height": "1",
        "padding": "20px 0px 20px 0px",
        "font-weight": "100",
        "color": "#bfbfbf",
        "font-family-cust": "",
        "font-family": "'Nunito', sans-serif",
        "margin": "0px 0px 0px 0px",
        "font-family-bk": "'Nunito', sans-serif",
        "text-align": "left"
      },
      "stylePropsTab": {
        "font-size": "3rem",
        "line-height": "1"
      },
      "stylePropsMob": {
        "font-size": "2.25rem",
        "line-height": "2.5rem"
      }
    }
  ],
  "dynamicText": {
    "styleProps": {
      "font-size": "1.875rem",
      "line-height": "2.25rem",
      "padding": "10px 0px 10px 0px",
      "text-align": "center"
    },
    "stylePropsTab": {
      "padding": "10px 0px 10px 0px"
    },
    "stylePropsMob": {
      "padding": "10px 0px 10px 0px"
    },
    "strings": []
  },
  "descriptionsStyleProps": {
    "padding": "10px 0px 10px 0px",
    "text-align": "center"
  },
  "descriptionsStylePropsTab": {
    "padding": "10px 0px 10px 0px"
  },
  "descriptionsStylePropsMob": {
    "padding": "10px 0px 10px 0px"
  },
  "descriptions": [],
  "buttonsStyleProps": {},
  "buttons": [],
  "emailSecStyleProps": {},
  "subscription": {
    "showSection": "hide",
    "display": "enable",
    "subConfigs": {
      "configType": "convertkit",
      "configUrl": "https://app.convertkit.com/forms/xxxxxx/subscriptions",
      "configPlaceholder": ""
    },
    "email_placeholder": {
      "text": "example@mail.com"
    },
    "buttonText": {
      "text": "Subscribe",
      "styleProps": {
        "background-color": "#1b1b31",
        "color": "#ffffff"
      }
    },
    "successMessage": {
      "text": "Thank you for the signup",
      "styleProps": {}
    },
    "errorMessage": {
      "text": "Something went wrong. Please try again.",
      "styleProps": {}
    }
  },
  "textsStyleProps": {
    "text-align": "center"
  },
  "texts": [],
  "editFormName": "HEADER_FORM_01",
  "metaDataId": 1746179807903,
  "afterIndex": 28,
  "blockId": 1746179807903,
  "textBlock": {
    "descriptions": [
      {
        "text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        "styleProps": {
          "font-size": "1.125rem",
          "line-height": "1.75rem",
          "color": "#ffffff"
        }
      },
      {
        "text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        "styleProps": {
          "font-size": "1.125rem",
          "line-height": "1.75rem",
          "color": "#ffffff"
        }
      }
    ],
    "headings": [
      {},
      {}
    ]
  },
  "fonts": {
    "headings": [
      ""
    ]
  },
  "stylePropsMob": {
    "padding": "60px 20px 60px 20px"
  },
  "stylePropsTab": {
    "padding": "80px 20px 80px 20px"
  },
  "containerStyleProps": {
    "padding": "0px 0px 0px 0px"
  },
  "containerStylePropsTab": {
    "padding": "0px 00px 0px 00px"
  }
}